import type { ErrorComponentProps } from '@tanstack/react-router';
import { NoConnectionScreen, NotFoundScreen, ServerErrorScreen } from '@eureca/ui';
import { ConsultantLayout } from '@/shared/consultant-layout';

/**
 * EU-686 (RN-20..25) — telas GLOBAIS de erro sistêmico do App Consultor,
 * consumindo o componente compartilhado do `@eureca/ui` com a variante
 * `consultants` (RN-21 — proibido cópia local por fluxo). 404, 500 e falha de
 * conexão MANTÊM o menu lateral (RN-25 — o consultor segue autenticado), por
 * isso rendem dentro do `ConsultantLayout`; a sessão expirada (sem menu,
 * RN-24) vive no `KeycloakGate`, acima do router.
 */

/** "Falar com o suporte" — central de ajuda da plataforma (Intercom). */
export const SUPPORT_URL = 'https://intercom.help/eureca_central/pt-BR';

const goHome = () => {
  window.location.href = '/';
};

const openSupport = () => {
  window.open(SUPPORT_URL, '_blank', 'noopener,noreferrer');
};

/**
 * O 404 SEM o layout, para telas que já rendem dentro do `ConsultantLayout` e
 * precisam trocar só o miolo — caso do perfil de um candidato inexistente
 * (RN-20/22, HAV-026). Mesma definição do `defaultNotFoundComponent`: rota
 * inexistente e RECURSO inexistente mostram exatamente a mesma tela, que é o
 * que a RN-21 pede ao proibir cópia local por fluxo.
 */
export function ConsultantNotFoundContent() {
  return <NotFoundScreen platform="consultants" onGoHome={goHome} />;
}

/** `defaultNotFoundComponent` — HAV-026 (menu mantido). */
export function ConsultantNotFoundScreen() {
  return (
    <ConsultantLayout activeMenuId="programs">
      <ConsultantNotFoundContent />
    </ConsultantLayout>
  );
}

/**
 * `defaultErrorComponent` — árvore offline-vs-servidor (RN-22, espelho do
 * RouterErrorScreen EU-711 do candidato): sem conexão → "Você está sem
 * internet"; senão → "Algo deu errado por aqui" (HAV-022/023, menu mantido).
 */
export function ConsultantRouterErrorScreen({ reset }: ErrorComponentProps) {
  return (
    <ConsultantLayout activeMenuId="programs">
      {typeof navigator !== 'undefined' && navigator.onLine === false ? (
        <NoConnectionScreen platform="consultants" onRetry={reset} />
      ) : (
        <ServerErrorScreen platform="consultants" onRetry={reset} onSupport={openSupport} />
      )}
    </ConsultantLayout>
  );
}
